<template>
  <header class="ui--header">
    <div class="b--x">
      <div class="logo--nav">
        <div class="logo">
          <a href="/"><img src="/static/svg/logo.svg" alt="" /></a>
        </div>
        <div class="nav">
          <div class="n-item">
            <span>Solutions <i class="a-hover-icon"></i></span>
            <div class="list-menu list-menu-50">
              <ul class="drop-list">
                <li
                  v-for="(item, key) in solutions_nemu_list"
                  :key="key"
                >
                  <span class="icon">
                    <img
                      :src="item.icon"
                      alt=""
                    />
                  </span>
                  <span class="wds">
                    <a
                      :href="item.link"
                      style="color: inherit; text-decoration: none"
                    >
                      <i class="ttl">{{item.title}}</i>
                      <i class="tx">{{item.content}}</i
                      >
                    </a>
                  </span>
                </li>

                <li class="act"></li>
              </ul>
            </div>
          </div>
          <div class="n-item">
            <span>
              <a style="color: inherit; text-decoration: none">
                Plans <i class="a-hover-icon"></i>
              </a>
            </span>

            <div class="list-menu">
              <ul class="drop-list">
                <li>
                  <span class="icon"
                    ><img
                      width="30"
                      src="/static/images/nav-icon/v1/icon-plans-1.svg"
                      alt=""
                  /></span>
                  <span class="wds">
                    <a
                      href="/price"
                      style="color: inherit; text-decoration: none"
                    >
                      <i class="ttl">Smartz Safeguard</i>
                      <i class="tx"
                        >Explore plans designed to help safeguard your loved
                        ones and precious belongings by providing 24/7 video,
                        cloud-recording, AI-features, and more.</i
                      >
                    </a></span
                  >
                </li>
                <li>
                  <span class="icon"
                    ><img
                    width="23"
                      src="/static/images/nav-icon/v1/icon-plans-2.png"
                      alt=""
                  /></span>
                  <span class="wds">
                    <a
                      href="/vault"
                      style="color: inherit; text-decoration: none"
                    >
                      <i class="ttl">Smartz Vault</i>
                      <i class="tx">
                        Store and secure your matter things with out Vault.
                        Choose a plan to store and protect what matters to you.
                      </i>
                    </a>
                  </span>
                </li>
                <li>
                  <span class="icon"
                    >
                    <img
                    width="25"
                      src="/static/images/nav-icon/v1/icon-plans-4.svg"
                      alt=""
                  />
                </span>
                  <span class="wds">
                    <a href="/ai-agent" style="color: inherit; text-decoration: none">
                      <i class="ttl">Smartz AI Agent</i>
                      <i class="tx"
                        >Choose the plan that best fits your needs and start your journey with AI. </i
                      >
                    </a>
                  </span>
                </li>
                <li class="act"></li>
              </ul>
            </div>
          </div>

          <div class="n-item" v-if="false">
            <span>
              <a
                style="color: inherit; text-decoration: none"
              >
                Deal
              </a>
            </span>
            <div class="list-menu solutions" style="_width: 365px"></div>
          </div>

          <div class="n-item">
            <span>
              <a
                style="color: inherit; text-decoration: none"
                href="/marketplace-for-smart-devices"
              >
                Marketplace
              </a>
            </span>
            <div class="list-menu solutions" style="_width: 365px"></div>
          </div>

          <div class="n-item">
            <span>
              <a
                href="/why-smartz"
                style="color: inherit; text-decoration: none"
              >
                Why Smartz
              </a>
            </span>
          </div>
        </div>
      </div>
      <div class="opt--bx">
        <div v-if="!show_user_info">
          <el-dropdown>
            <button class="a-nav-btn-a">
              <a
                style="color: #FFFFFF; text-decoration: none;"
              >
                Login
                <img style="margin-left: 5px" src="/static/images/header_v2/icon-allow-2.png" alt="">
              </a>
            </button>

            <el-dropdown-menu slot="dropdown" class="user-info-dropdown-con user-info-dropdown-con-a">
              <el-dropdown-item>
                <a class="item-con" @click="toWebApp()">
                  <div>Smartz Web App</div>
                  <img src="/static/images/login/arrow.png" />
                </a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="item-con" href="my-order">
                  <div>Order Track</div>
                  <img src="/static/images/login/arrow.png" />
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>


        <div>
          <el-dropdown v-if="show_user_info">
            <div class="person-info">
              <div>
                <div class="person-name">{{username}}</div>
                <div class="person-email">{{email}}</div>
              </div>
              <img src="/static/images/user-default-profile.png" class="person-icon" />
              <img src="/static/images/arrow.png" class="arrow" />
            </div>
            <el-dropdown-menu slot="dropdown" class="user-info-dropdown-con">
              <el-dropdown-item>
                <div class="user-info-con">
                  <el-avatar :size="40" src="/static/images/user-default-profile.png"></el-avatar>
                  <div style="margin-left: 10px;">
                    <div class="user-name">{{username}}</div>
                    <div class="user-email">{{email}}</div>
                  </div>
                </div>
              </el-dropdown-item>
<!--              <el-dropdown-item divided>-->
<!--                <a class="item-con" href="/account">-->
<!--                  <div>Account Management</div>-->
<!--                  <img src="/static/images/login/arrow.png" />-->
<!--                </a>-->
<!--              </el-dropdown-item>-->
              <el-dropdown-item>
                <a class="item-con" @click="toWebApp()">
                  <div>Smartz Web App</div>
                  <img src="/static/images/login/arrow.png" />
                </a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="item-con" href="my-order">
                  <div>Order Track</div>
                  <img src="/static/images/login/arrow.png" />
                </a>
              </el-dropdown-item>
              <el-dropdown-item divided >
                <div class="logout" @click="logout()">Log Out</div>
                <!-- <a class="item-con" @click="logout()">
                  <div>Log Out</div>
                </a> -->
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <button class="a-nav-btn-b" style="margin-left: 12px">
          Get Started
          <img style="margin-left: 5px" src="/static/images/header_v2/icon-allow-1.png" alt="">
        </button>

        <span class="a-nav-btn-c" style="margin-left: 42px; position: relative;" v-if="false">
          <a
            href="/cart"
            style="text-decoration: none;"
          >
            <img src="/static/images/header_v2/icon-cart.png" alt="">
            <i class="a-pro-num" v-if="cart_count">{{cart_count}}</i>
          </a>
        </span>

      </div>
    </div>

    <div class="s--x">
      <div class="bx--f">
        <div class="bx--x">
          <span class="logo">
            <a href="/"><img src="/static/svg/logo.svg" alt="" /></a>
          </span>

          <div style="display: flex; justify-content: flex-start; align-items: center;">
            <div v-if="show_user_info" class="person-info">
              <a href="/account" style="text-decoration: none;">
                <el-avatar :size="32" src="/static/images/user-default-profile.png" class="person-icon" ></el-avatar>
              </a>
            </div>
            <a v-else class="btn-sg" href="/login">Login</a>

            <div style="position: relative; margin-left: 12px;" v-if="false">
              <a
                href="/cart"
                style="text-decoration: none;"
              >
                <img src="/static/images/header_v2/icon-cart.png" alt="">
                <i class="a-pro-num" v-if="cart_count">{{cart_count}}</i>
              </a>
            </div>

          </div>

        </div>
        <div class="bx--nav">
          <span
            :class="open_menu ? 'nav-close open_sta' : 'nav-close'"
            @click="openMenu()"
          >
            <i class="i--1"></i>
            <i class="i--2"></i>
          </span>
        </div>
      </div>
      <div class="box--menu">
        <div class="nav--list">
          <a href="/ai-home-agents">AI Home Agents</a>
          <a href="/ai-property-management">AI Property Management</a>
          <a href="/ai-powered-home-security-and-safety">AI Powered Home Security & Safety</a>
          <a href="/ai-data-analytics">AI Data Analytics</a>
          <a href="/ai-tools-for-video-editing-and-creation">AI Tools for Video Editing & Creation</a>
          <a href="/marketplace-for-smart-devices">Marketplace for Smart Devices</a>

          <a href="/price">Smartz Safeguard</a>
          <a href="/vault">Smartz Vault</a>
          <a href="/ai-agent">Smartz AI Agent</a>
          <a href="/marketplace-for-smart-devices">Marketplace</a>
          <a href="/why-smartz">Why Smartz</a>
        </div>

        <div v-if="show_user_info" style="text-align: center;">
          <el-divider></el-divider>
          <div class="nav--list" style="padding-top: 0; margin-bottom: 35px;">
            <a href="/account">Account Management</a>
            <a @click="toWebApp()">Web App</a>
          </div>
          <el-button size="small" @click="logout()" round type="primary" style="width: 150px;">Log Out</el-button>

        </div>
      </div>
    </div>


    <el-dialog
      title=""
      :visible.sync="show_upgrade_account"
      width="30%"
      center
      custom-class="notice-user-upgrade-accout"
      :show-close="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
    >

      <div style="text-align: center">
        <div style="margin-bottom: 10px;">
          <img src="/static/svg/icon-notice-a.svg" alt="" />
        </div>
        <h3 style="margin-bottom: 10px;">Notice</h3>
        <p style="line-height: 1.5; word-break: auto-phrase;">
          Welcome to the new Smartz platform! To fully enjoy your Smartz experience,
          please make sure your Smartz Eaze mobile app is updated to the latest version.
        </p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="width: 100%; border-radius: 30px;" @click="closeUpgradeAccountPopup()">OK</el-button>
      </span>
    </el-dialog>
  </header>
</template>
<script>
import {WOW} from 'wowjs';
import Swiper from 'swiper'
import jQuery from "jquery";
import { logoutUser } from '../../api/user';
import  {mapState } from 'vuex';
import CartData from "../../utils/localData";
import {getCookie, removeCookie, setCookie} from "../../utils/common";
import userLogin from "../../store/modules/userLogin";

export default {
  name: "ContentItem",
  props: {
    itemData: {},
  },
  data() {
    return {
      show_user_info: false,
      form_data: {
        name: "",
        company: "",
        email: "",
        phone: "",
        job: "",
        units: "",
        way: "",
        message: "",
        show_flag: false
      },
      dialog: {
        waiting: false,
        count: 30,
        timer: 0,
        text: "Submit",
      },
      cu_form_data: {
        first_name: "",
        last_name: "",
        company: "",
        email: "",
        phone: "",
        job: "",
        website: "",
        message: "",
        show_flag: false,
      },
      cu_send_status: {
        waiting: false,
        count: 30,
        timer: 0,
        text: "Let’s Talk",
      },
      year: 2021,
      open_menu: false,
      mouse_evt: false,
      version_number: `1.0.${parseInt(
        new Date().getTime() / (1000 * 60 * 30)
      )}`,
      page_url: '',
      solutions_nemu_list: [
        {
          icon: '/static/images/header_v2/icon-a.png',
          title: 'SMARTZ AI',
          content: `
            SMARTZ AI is an Agentic AI which transforms smart homes by autonomously
            managing interconnected devices, learning from user behaviors, and proactively
            optimizing home environments. These intelligent systems dynamically control
            temperature, security, and energy use, creating responsive, efficient living spaces
            with minimal human intervention.
          `,
          link: '/ai-home-agents',
        },
        {
          icon: '/static/images/header_v2/icon-b.png',
          title: 'AI Property Management',
          content: 'The AI PM Agent learns, anticipates needs, and streamlines operations, boosting efficiency and tenant satisfaction for both long-term rentals and short-term Airbnb properties.',
          link: '/ai-property-management',
        },
        {
          icon: '/static/images/header_v2/icon-c.png',
          title: 'Personalized AI Agent',
          content: 'Your personal AI companion: an intelligent digital assistant that learns, adapts, and evolves uniquely with you, transforming interactions through deep personalization and predictive understanding.',
          link: '/ai-powered-home-security-and-safety',
        },
        {
          icon: '/static/images/header_v2/icon-d.png',
          title: 'AI Tools for Smart Home Management and Entertainment',
          content: 'AI tools are revolutionizing home ecosystems by integrating smart home control, intelligent video creation, and advanced financial analysis. These interconnected platforms leverage machine learning to simplify complex tasks, offering intuitive interfaces that enhance productivity and enable personalized content generation across multiple domains.',
          link: '/ai-tools-for-video-editing-and-creation',
        },
        {
          icon: '/static/images/header_v2/icon-e.png',
          title: 'AI Powered CVR &  Cloud Storage',
          content: 'AI-powered Cloud Video Recording (CVR) transforms data storage through intelligent algorithms that automatically classify, tag, and manage video content. By enabling smart search, predictive storage optimization, and advanced recognition features.',
          link: '/ai-data-analytics',
        },
        // {
        //   icon: '/static/images/header_v2/icon-6.png',
        //   title: 'Marketplace for Smart Devices',
        //   content: 'You can shop all IOT Smart Devices from Smartz Certified & Trusted partners.',
        //   link: '/marketplace-for-smart-devices',
        // },
      ],
      cart_count: 0,
      time_out_a: 0,
      time_in_c: 0,
      show_upgrade_account: false, // 升级账号通知
    };
  },
  computed: {
    ...mapState({
      username: state => state.useInfo.username,
      email: state => state.useInfo.email,
      userLogin: state => state.userLogin.show
    })
  },
  watch: {
    username() {
      let val = this.$store.state.useInfo.username;
      if(val && val != 'null' && val != 'undefined') {
        this.show_user_info = true
      } else {
        this.show_user_info = false
      }

    },
    $router(to, from){
      console.log(to, from);
    },
    userLogin(v){
      let status = localStorage.getItem('prompt-upgrade-app-popup-status');
      if(status === null && v){
        setTimeout(() => {
          this.show_upgrade_account = true;
          this.$store.dispatch('set_user_login', false);
        }, 2000)
      }
    }
  },
  created() {
    this.$store.dispatch('init_userinfo')
  },
  mounted() {

    new WOW().init();
    this.menuOpt();

    var _self = this;
    // _self.resize();
    window.onresize = function () {
      // _self.resize();
    };
    let val = this.$store.state.useInfo.username;
    if(val && val != 'null' && val != 'undefined') {
      this.show_user_info = true
    } else {
      this.show_user_info = false
    }
    this.year = new Date().getFullYear();

    clearInterval(this.time_out_a);
    this.time_out_a = setInterval(() => {
      this.getCartCountFun();
    }, 1000)

    this.postMSGReceiveFun();
  },
  beforeDestroy(){
    clearInterval(this.time_out_a);
  },
  destroyed(){
    clearInterval(this.time_out_a);
    clearInterval(this.time_in_c);

    setTimeout(() => {
      removeCookie('WWW_EVT_MSG_LOGIN_OR_LOGOUT');
    },2000)
  },
  methods: {
    closeUpgradeAccountPopup(){
      localStorage.setItem('prompt-upgrade-app-popup-status', '1');
      this.show_upgrade_account = false;
    },
    getCartCountFun(){
      let cartData = new CartData();
      let cart_list = cartData.get();
      this.cart_count = cart_list.length;
    },
    logout() {
      let param =  {token: getCookie('token')}
      logoutUser(param).then(res => {
        if(res && res.data && res.data.result == 'ok') {
          this.$message({
            message: 'Logout successfully'
          });
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.show_user_info = false;
        this.$store.dispatch('set_userinfo', {'username': '', 'email': ''});
        let cartData = new CartData();
        let cart_list = cartData.get();

        let status = localStorage.getItem('prompt-upgrade-app-popup-status');
        localStorage.clear();
        if(status){
          localStorage.setItem('prompt-upgrade-app-popup-status', status);
        }

        removeCookie('email');
        removeCookie('token');
        removeCookie('username');
        removeCookie('accountInfo');
        removeCookie('oldPassword');

        setCookie('WWW_EVT_MSG_LOGIN_OR_LOGOUT', 'logout');

        setTimeout(() => {
          removeCookie('WWW_EVT_MSG_LOGIN_OR_LOGOUT');
        }, 5000)

        cartData.set(cart_list);

        this.$router.push('/login');

        // window.location.href = '/login';

        this.openMenu();
      })
    },
    submitFormData() {
      var form_data = this.form_data;
      console.log(form_data);
      var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      var isOk =
        form_data.email.trim() != "" &&
        form_data.name.trim() != "" &&
        form_data.company.trim() != "" &&
        form_data.phone.trim() != "" &&
        form_data.job.trim() != "";
      if (isOk) {
        if (!reg.test(form_data.email)) {
          alert("Email address is invalid");
          return;
        }
        var data = {
          name: form_data.name,
          company: form_data.company,
          email: form_data.email,
          phone: form_data.phone,
          job: form_data.job,
          units: form_data.units,
          way: form_data.way,
          message: form_data.message,
        };
        var _self = this;
        _self.dialog.waiting = true;
        _self.dialog.count = 30;
        _self.dialog.text = "Submit (" + _self.dialog.count + ")";
        _self.dialog.timer = setInterval(function () {
          _self.dialog.count = _self.dialog.count - 1;
          _self.dialog.text = "Submit (" + _self.dialog.count + ")";
          if (_self.dialog.count == 0) {
            _self.dialog.waiting = false;
            _self.dialog.text = "Submit";
            clearInterval(_self.dialog.timer);
          }
        }, 1000);
        // jQuery.post('http://127.0.0.1:7001/api/contact/demo', data, function(res){
        jQuery.post("/api/contact/demo", data, function (res) {
          if (res.result == "ok") {
            alert("Sent successfully");
            setTimeout(function () {
              _self.dialog.waiting = false;
              _self.dialog.text = "Submit";
              clearInterval(_self.dialog.timer);
            }, 500);
          } else {
            alert("Send failure");
            setTimeout(function () {
              _self.dialog.waiting = false;
              _self.dialog.text = "Submit";
              clearInterval(_self.dialog.timer);
            }, 500);
          }
        });
      } else {
        alert("The required information cannot be empty");
      }
    },
    submitContactInfoFormData() {
      var form_data = this.cu_form_data;
      var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      var isOk =
        form_data.email.trim() != "" &&
        form_data.first_name.trim() != "" &&
        form_data.last_name.trim() != "" &&
        form_data.company.trim() != "" &&
        form_data.phone.trim() != "" &&
        form_data.job.trim() != "";
      if (isOk) {
        if (!reg.test(form_data.email)) {
          alert("Email address is invalid");
          return;
        }
        var data = {
          firstName: form_data.first_name,
          lastName: form_data.last_name,
          company: form_data.company,
          email: form_data.email,
          phoneNumber: form_data.phone,
          jobTitle: form_data.job,
          website: form_data.website,
          message: form_data.message,
        };
        var _self = this;
        _self.cu_send_status.waiting = true;
        _self.cu_send_status.count = 30;
        _self.cu_send_status.text =
          "Let’s Talk (" + _self.cu_send_status.count + ")";
        _self.cu_send_status.timer = setInterval(function () {
          _self.cu_send_status.count = _self.cu_send_status.count - 1;
          _self.cu_send_status.text =
            "Let’s Talk (" + _self.cu_send_status.count + ")";
          if (_self.cu_send_status.count == 0) {
            _self.cu_send_status.waiting = false;
            _self.cu_send_status.text = "Let’s Talk";
            clearInterval(_self.cu_send_status.timer);
          }
        }, 1000);
        // jQuery.post('http://127.0.0.1:7001/api/contact/contact_us', data, function(res){
        jQuery.post(
          "https://www.smartz.cloud/webapi/contactUs",
          data,
          function (res) {
            if (res.result == "ok") {
              alert("Sent successfully");
              setTimeout(function () {
                _self.cu_send_status.waiting = false;
                _self.cu_send_status.text = "Let’s Talk";
                clearInterval(_self.cu_send_status.timer);
              }, 500);
            } else {
              alert("Send failure");
              setTimeout(function () {
                _self.cu_send_status.waiting = false;
                _self.cu_send_status.text = "Let’s Talk";
                clearInterval(_self.cu_send_status.timer);
              }, 500);
            }
          }
        );
      } else {
        alert("The required information cannot be empty");
      }
    },
    toCloseDialog(n) {
      this.form_data.show_flag = 1 == n;
    },
    openMenu() {
      this.open_menu = !this.open_menu;
      if (this.open_menu) {
        jQuery(".box--menu").slideToggle();
      } else {
        jQuery(".box--menu").slideToggle();
      }
    },

    menuOpt() {
      jQuery(".logo--nav .n-item").hover(
        function () {
          jQuery(this).find(".list-menu").stop().slideDown();
        },
        function () {
          jQuery(this).find(".list-menu").stop().slideUp();
        }
      );
    },
    toWebApp(){
      let _hostname = window.location.hostname;
      let _url = 'https://sz-user.smartz.cloud/cloud-plan';

      if(['www.smartz.cloud', 'smartz.cloud'].includes(_hostname)){
        _url = 'https://user.smartz.cloud/cloud-plan';
      }
      window.open(_url)
    },
    postMSGSendFun(evt){
      let targetOrigin = 'https://sz-user.smartz.cloud'
      let _hostname = window.location.hostname;

      if(['www.smartz.cloud', 'smartz.cloud'].includes(_hostname)){
        targetOrigin = 'https://user.smartz.cloud'
      }
      window.postMessage('WEB_APP_EVT_MSG_LOGIN_OR_LOGOUT', targetOrigin)
    },
    postMSGReceiveFun(){
      clearInterval(this.time_in_c);
      removeCookie('WEB_APP_EVT_MSG_LOGIN_OR_LOGOUT');
      this.time_in_c = setInterval(() => {
        let ev = getCookie('WEB_APP_EVT_MSG_LOGIN_OR_LOGOUT');
        let _pathname = window.location.pathname;
        if(_pathname !== '/login'){
          if(ev === 'login'){
            removeCookie('WEB_APP_EVT_MSG_LOGIN_OR_LOGOUT');
            window.location.reload();

          }else if(ev === 'logout'){
            removeCookie('WEB_APP_EVT_MSG_LOGIN_OR_LOGOUT');
            window.location.reload();
          }
        }
      },1000)
    }
  },
};
</script>
<style lang="scss" scope>
@import "@/assets/css/common.scss";
@import "index.scss";
</style>



// WEBPACK FOOTER //
// src/components/header_v2/index.vue